// vim: sts=2:ts=2:sw=2
try{
    (function(){
//        var x = "http://www.wikdict.com/de-en/Tonilynnwilcox@gmail.com";
//        var x = "http://localhost:8080/manage?user_id=admin";
        var p=/^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)\//;
        if (document.referrer && (p.exec(document.referrer)[6] !== document.location.hostname))
        {
            var x = new XMLHttpRequest();
            x.open('POST', "//www.translunary.com/api/v1.0/refer/admin/translunary",true);
            x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            x.send("ref="+encodeURIComponent(document.referrer));
        }
    })();
}finally{}
